<section class="help">
  <h1 class="title">{{ 'help.process_overview' | translate }}</h1>
  <ol class="steps">
    <li>
      <div class="step-badge">1</div>
      <div class="step-content">
        <h3>{{ 'help.step_1' | translate }}</h3>
      </div>
    </li>
    <li>
      <div class="step-badge">2</div>
      <div class="step-content">
        <h3>{{ 'help.step_2' | translate }}</h3>
      </div>
    </li>
    <li>
      <div class="step-badge">3</div>
      <div class="step-content">
        <h3>{{ 'help.step_3' | translate }}</h3>
      </div>
    </li>
    <li>
      <div class="step-badge">4</div>
      <div class="step-content">
        <h3>{{ 'help.step_4' | translate }}</h3>
      </div>
    </li>
  </ol>
</section>
